import { get } from 'lodash';
import { getYearFromUtc, formatDate } from '../../utils/date';

const activeSeasons = [];

export const setActiveSeasons = (seasons) => {
    activeSeasons.splice(0);
    activeSeasons.push(...seasons);
};

const getCurrentSeasonYear = (racingType) => {
    const currentYear = new Date().getUTCFullYear();
    return (racingType === 'jumps') ? currentYear - 1 : currentYear;
};

export function getRaceTypeStartYear(racingType, country, seasons) {
    const startYearUTC = get(seasons, [racingType, country], undefined);
    return startYearUTC
        ? getYearFromUtc(startYearUTC)
        : getCurrentSeasonYear(racingType);
}

export function getCurrentSeasonEndYear(racingType, country) {
    const currentYear = new Date().getUTCFullYear();
    let currentSeasonCode = 'F';
    if (racingType === 'jumps') {
        currentSeasonCode = country === 'IRE' ? 'I' : 'J';
    }
    const activeSeason = activeSeasons
        .find(({ seasonTypeCode }) => seasonTypeCode === currentSeasonCode);

    return activeSeason ? getYearFromUtc(activeSeason.seasonEndDate) : currentYear;
}

export function getPeriods(startYear, endYear, raceType) {
    const periods = [];

    let labelTemplate = year => `${year}`;
    let valueTemplate = year => `${year}/${year}`;

    if (raceType === 'jumps') {
        labelTemplate = year => `${year - 1}-${(year).toString().slice(2)}`;
        valueTemplate = year => `${year - 1}/${year}`;
    }

    for (let year = startYear; year > endYear; year -= 1) {
        periods.push(
            {
                label: labelTemplate(year),
                value: valueTemplate(year),
            }
        );
    }

    return periods;
}

export const getAll = (lastYear, currentYear) => ({
    label: 'All',
    value: `${lastYear}/${currentYear}/all`,
});

export const getCurrent = (currentYear, type) => ({
    label: `Current ${type === 'jumps' ? 'season' : 'year'}`,
    value: `${type === 'jumps' ? currentYear - 1 : currentYear}/${currentYear}/current`,
});


export const getLast5 = (currentSeasonEndYear, type) => {
    const isJumps = type === 'jumps';
    const periodStartYear = currentSeasonEndYear - (isJumps ? 5 : 4);
    return ({
        label: `Last 5 ${isJumps ? 'season' : 'year'}s`,
        value: `${periodStartYear}/${currentSeasonEndYear}/last5`,
    });
};

export const getAvailable = (seasonsAvailable = {}, type, useSingleYearFormat = false) =>
    (seasonsAvailable[type] ?
        seasonsAvailable[type].map(({ seasonStartDate, seasonEndDate }) => {
            const startYear = formatDate(seasonStartDate, 'Y');
            return {
                value: useSingleYearFormat ?
                    startYear :
                    `${getYearFromUtc(seasonStartDate)}/${getYearFromUtc(seasonEndDate)}`,
                label: type === 'FLAT' ?
                    startYear :
                    `${startYear}-${formatDate(seasonEndDate, 'YY')}`,
            };
        }) : []);

// removing helper suffixes from option value
export const removeExtra = val =>
    val.replace('/last5', '').replace('/current', '').replace('/all', '');

// remove end year from option value
// '2015-2016' => '2015'
export const removeEndYear = option => ({
    ...option,
    value: option.value.split('/')[0],
});




// WEBPACK FOOTER //
// ./src/js/utils/filter/timePeriods.js